/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as PostSignInPasskeyRouteImport } from './routes/post-sign-in-passkey'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RecordsRecordIdRouteImport } from './routes/records.$recordId'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const PostSignInPasskeyRoute = PostSignInPasskeyRouteImport.update({
  id: '/post-sign-in-passkey',
  path: '/post-sign-in-passkey',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordsRecordIdRoute = RecordsRecordIdRouteImport.update({
  id: '/records/$recordId',
  path: '/records/$recordId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/post-sign-in-passkey': typeof PostSignInPasskeyRoute
  '/sign-in': typeof SignInRoute
  '/records/$recordId': typeof RecordsRecordIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/post-sign-in-passkey': typeof PostSignInPasskeyRoute
  '/sign-in': typeof SignInRoute
  '/records/$recordId': typeof RecordsRecordIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/post-sign-in-passkey': typeof PostSignInPasskeyRoute
  '/sign-in': typeof SignInRoute
  '/records/$recordId': typeof RecordsRecordIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/post-sign-in-passkey'
    | '/sign-in'
    | '/records/$recordId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/post-sign-in-passkey'
    | '/sign-in'
    | '/records/$recordId'
  id:
    | '__root__'
    | '/'
    | '/onboarding'
    | '/post-sign-in-passkey'
    | '/sign-in'
    | '/records/$recordId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OnboardingRoute: typeof OnboardingRoute
  PostSignInPasskeyRoute: typeof PostSignInPasskeyRoute
  SignInRoute: typeof SignInRoute
  RecordsRecordIdRoute: typeof RecordsRecordIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post-sign-in-passkey': {
      id: '/post-sign-in-passkey'
      path: '/post-sign-in-passkey'
      fullPath: '/post-sign-in-passkey'
      preLoaderRoute: typeof PostSignInPasskeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/records/$recordId': {
      id: '/records/$recordId'
      path: '/records/$recordId'
      fullPath: '/records/$recordId'
      preLoaderRoute: typeof RecordsRecordIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OnboardingRoute: OnboardingRoute,
  PostSignInPasskeyRoute: PostSignInPasskeyRoute,
  SignInRoute: SignInRoute,
  RecordsRecordIdRoute: RecordsRecordIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
